import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🚗", key: "one" },
  { emoji: "🧭", key: "twoToThree" },
  { emoji: "🎨", key: "fourToSix" },
  { emoji: "🔥", key: "fleet" },
]

export default function CarsGarageSizePage() {
  return <RadioCardListPage translationKey="carsGarageSize" options={OPTIONS} />
}
